import { style } from "@vanilla-extract/css";
import { vars } from "../../../styles";

export const contentStyles = style({
  padding: `0 ${vars.space.m}`,
  overflowY: "auto",
  scrollBehavior: "smooth",
});

export const filterButtonGroupWrapper = style({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  height: "100%",
});

export const radioButtonWrapper = style({
  paddingTop: vars.space.s,
  paddingBottom: vars.space.s,
  paddingInlineEnd: vars.space.xs,
});
